webpackJsonp([263791100135453],{

/***/ 63:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"banner":"src-components-Banner----banner-module---banner---31KmZ src-styles----utils---shadowLvl1---1bhdJ"};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bannerModule = __webpack_require__(63);
	
	var _bannerModule2 = _interopRequireDefault(_bannerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Banner.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _bannerModule2.default.banner },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        this.props.children
	      )
	    );
	  };
	
	  return Banner;
	}(_react2.default.Component);
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boxing.023782d4.jpg";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/small-group-training.0da18864.jpg";

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	var _Banner = __webpack_require__(56);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Button = __webpack_require__(23);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Content = __webpack_require__(57);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(29);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _HalfHero = __webpack_require__(30);
	
	var _HalfHero2 = _interopRequireDefault(_HalfHero);
	
	var _Header = __webpack_require__(31);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Hero = __webpack_require__(32);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _IconList = __webpack_require__(33);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _Testimonial = __webpack_require__(34);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Testimonials = __webpack_require__(35);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _boxing = __webpack_require__(72);
	
	var _boxing2 = _interopRequireDefault(_boxing);
	
	var _smallGroupTraining = __webpack_require__(73);
	
	var _smallGroupTraining2 = _interopRequireDefault(_smallGroupTraining);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import menu from '../scripts/menu.js';
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Banner2.default,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "About Personal Trainer Jerron Torbert"
	      )
	    ),
	    _react2.default.createElement(
	      _Content2.default,
	      null,
	      _react2.default.createElement(
	        "h3",
	        null,
	        "\u201CYour goals, my passion!\u201D"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "My interest into becoming a personal trainer/nutritionist began when I started to live a healthy lifestyle and people inquired as to how I built my physique and saw my work ethic in the gym. In my youth I participated in sports including baseball and boxing being a \u201CGolden Gloves\u201D champion and continued to keep a regular workout program afterwards."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "My passion now is to help others experience the same benefits I\u2019ve experienced through regular exercise and a healthy diet. Obtaining my certifications in Personal Training and Nutrition Specialist from NASM (National Association of Sports Medicine), two years of personal training experience (11 months at 24 Hour Fitness and 1 year as a private trainer at Will Power Fitness in DTC), and 10 years in the food industry as a Chef has equipped me with the tools to help my clients live healthier lifestyles and obtain their fitness goals."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "With these tools I personally \u201CCustomFIT\u201D fitness and nutrition to fit each client's specific goals and needs. I continue to learn and add to my knowledge/value as a trainer and implement my strategies in my own training to ensure the most effective techniques to drive results in the programs I design for each of my clients."
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { to: '#get-started', type: 'href' },
	        "Get Started!"
	      )
	    ),
	    _react2.default.createElement(
	      _IconList2.default,
	      {
	        title: "Personal Training Programs",
	        columns: "2" },
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Lean & Mean"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Time to get shredded! Lean & Mean is a high intensity designed program to transform your physique. This program is great for both men and women!"
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Includes:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Fat destroying cardio routines"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Video demonstrations"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Nutritional and supplementation guidelines"
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { href: '#get-started' },
	          "Get Started!"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Ripped Core"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Wear that swimsuit with confidence! Ripped Core is a great program for men and women!"
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Includes:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Ab specific exercise to work all areas"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Video demonstrations"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Nutritional guideline"
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { href: '#get-started' },
	          "Get Started!"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Mass Gains"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Build a head turning physique! Mass Gains is trainer Jerron Torbert's favorite routine."
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Includes:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Fundamental exercises, rep ranges, sets, and rest periods"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Key high intensity techniques"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Video demonstrations"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Nutritional and supplementation guidelines"
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { href: '#get-started' },
	          "Get Started!"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Strength Driven Training"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Time to move some weight! Trainer Jerron Torbert knows how to increase strength: he has a 1350 lb total in the Powerlifting movements (the Squat, Benchpress, and Deadlift) at 190 lbs"
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Includes:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Proven strength techniques"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Fundamental exercises, rep ranges, sets, and rest periods"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Strength specific nutritional plan"
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Supplementation guideline"
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { href: '#get-started' },
	          "Get Started!"
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-9376088008c7bab95072.js